<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
          <b-overlay :show="loadingVrify">
            <b-row>
                <b-col  v-if="loading" lg="12" sm="12" class="form-for-textarea">
                    <h4 class="text-center">{{ $t('externalUser.loading') }} .....</h4>
                </b-col>
                <b-col v-else lg="12" sm="12" class="form-for-textarea" style="border:1px solid gray">
                    <div class="row mt-4">
                        <div class="col-md-8">
                            <p style="font-size:16px;color:black;font-weight:bold" class="p-0 m-0">{{ $t('externalUser.payment_recept') }}</p>
                        </div>
                        <div class="col-md-4 text-dark">
                            <table>
                                <tr>
                                    <td>{{ $t('externalUser.production.receive_id') }}</td>
                                    <td>: {{ formData.delivery_rec_main.receive_id }}</td>
                                </tr>
                                <tr>
                                    <td>{{ $t('retailerManagement.receive_date') }}</td>
                                    <td>: {{ formData.delivery_rec_main.receive_date | dateFormat }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="row mt-5">
                        <div class="col-md-12 text-dark">
                            <table>
                                <tr>
                                    <td>{{ $t('sales_center.total_amount') }} </td>
                                    <td>: {{ formData.amount }}</td>
                                </tr>
                                <tr>
                                    <td>{{ $t('externalUser.transaction_no') }}</td>
                                    <td>: {{ formData.transaction_no }}</td>
                                </tr>
                                <tr>
                                    <td>{{ $t('externalUser.payment_date') }}</td>
                                    <td>: {{ formData.created_at | dateFormat }}</td>
                                </tr>
                                <tr>
                                    <td>{{ $t('externalUser.voucher_no') }}</td>
                                    <td>: {{ formData.voucher_no }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <p style="font-size:16px;color:black;font-weight:bold" class="mt-3 p-0 m-0"><u>{{ $t('externalUser.product_list') }}</u></p>
                    <b-table-simple striped bordered small>
                        <b-tr>
                            <b-th>{{ $t('globalTrans.sl_no') }}</b-th>
                            <b-th>{{ $t('retailerManagement.product_name') }}</b-th>
                            <b-th>{{ $t('retailerManagement.unit') }}</b-th>
                            <b-th>{{ $t('retailerManagement.request_quantity') }}</b-th>
                            <b-th>{{ $t('retailerManagement.unit_price') }}</b-th>
                            <b-th>{{ $t('retailerManagement.total_price') }}</b-th>
                        </b-tr>
                        <b-tr v-for="(item, index) in formData.delivery_rec_main.details" :key="index">
                            <b-td>{{ $n(index + 1) }}</b-td>
                            <b-td>{{ productNameById(item.product_id) }}</b-td>
                            <b-td>{{ $n(item.quantity) }}</b-td>
                            <b-td>{{ $n(item.receive_quantity) }}</b-td>
                            <b-td>{{ $n(item.unit_price) }}</b-td>
                            <b-td>{{ $n(item.total_price) }}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-td colspan="5">
                                <span style="margin-left:85%">{{ $t('sales_center.grand_total') }}</span>
                            </b-td>
                            <td>{{ formData.delivery_rec_main.total_amount }}</td>
                        </b-tr>
                        <b-tr v-if="formData.delivery_rec_main.due_amount > 0">
                            <b-td colspan="5">
                                <span style="margin-left:85%">{{ $t('externalUser.due_amount') }}</span>
                            </b-td>
                            <td>{{ formData.delivery_rec_main.due_amount }}</td>
                        </b-tr>
                    </b-table-simple>
                    <div class="col-md-12 p-0 m-0 pb-4">
                        <p style="font-size:16px;color:black;font-weight:bold" class="mt-3 p-0 m-0"><u>{{ $t('committee.document') }} : </u></p>
                        <b-img style='height:300px; width:80%' fluid :src="baseUrl + 'download-attachment?file=uploads/security_payment/original/' + formData.voucher"  alt="Right image"></b-img>
                    </div>
                </b-col>
                <div class="col text-right mt-4">
                    <b-button type="button" @click="verifyPayment()" variant="primary" class="mr-2">{{ $t('globalTrans.verify') }}</b-button>
                    <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-verify')">{{ $t('globalTrans.close') }}</b-button>
                </div>
            </b-row>
          </b-overlay>
      </b-col>
    </b-row>
  </b-container>
</template>
<style>
.form-for-textarea textarea{ line-height: 18px !important;height: 54px !important; }
</style>
<script>
import { core } from '@/config/pluginInit'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { PaymentShow, checkPaymentVerify } from '../../api/routes'
export default {
  props: ['id'],
  created () {
    if (this.id) {
      this.getagentData()
    }
  },
  mounted () {
    core.index()
  },
  data () {
    return {
      formData: '',
      loading: false,
      loadingVrify: false,
      baseUrl: productionServiceBaseUrl
    }
  },
  computed: {
  },
  methods: {
    getDueAmount () {
       return this.formData.delivery_rec_main.total_amount - this.formData.amount
    },
    getagentData () {
        this.loading = true
        RestApi.getData(productionServiceBaseUrl, PaymentShow + `/${this.id}`).then(response => {
            if (response.success) {
                const tmpData = response.data
                this.formData = tmpData
            }
            this.loading = false
        })
    },
    getGrandTotal () {
      const result = this.formData.delivery_rec_main.details.reduce((total, item) => total + parseFloat(item.total_price), 0)
      const total = parseFloat(result)
      return total
    },
     productNameById (id) {
        const product = this.$store.state.ProductionService.commonObj.productList.find(product => product.value === id)
        if (typeof product === 'undefined') {
            return ''
        } else {
            if (this.$i18n.locale === 'bn') {
                return product.text_bn
            } else {
                return product.text_en
            }
        }
    },
    verifyPayment () {
      this.loadingVrify = true
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.putData(productionServiceBaseUrl, `${checkPaymentVerify}/${this.id}`).then(response => {
        this.loadingVrify = false
        if (response.success) {
            if (response.notification && this.$store.state.emitNotification) {
              const notification = response.notification
              this.$socket.emit('send-notification', notification)
            }
          this.$toast.success({
            title: 'Success',
            message: 'Payment verify success.',
            color: '#D6E09B'
          })
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: true })
          this.$bvModal.hide('modal-verify')
        }
      })
    }
  }
}
</script>
